<template>
    <div class="solveBox"  >
        <div class="solveItem"  v-for="item in solveList" :key="item.ID"  @click="goSolveShow(item)">
          <p class="solveItemImg">
            <img class="CNewItemImgSelf" v-lazy="item.TitlePic" :key="item.TitlePic">
              <!-- <el-image class="CNewItemImgSelf" :src="item.TitlePic">
                <div slot="error" class="image-slot">
                   <img src="~@/assets/img/noNews.png" alt="" >
                 </div>
              </el-image> -->
          </p>
          <p class="solveItemTitle">{{item.Title}}</p>
          <p class="solveItemP">{{item.AddTime|timeFormat}}</p>
        </div>
        <div v-if='!solveList.length' class="noSolveItem">
          <img src="~@/assets/img/noContent.png" alt="" >
        </div>
    </div>
</template>

<script>
// 获取解决方案列表
import { getSolveList } from '@/api/solve'
// 引入时间格式过滤
import { timeFormat } from '@/utils/myFilters'
// 引入根路径
import request from '@/utils/request'
export default {
  props: ['solveId'],
  data () {
    return {
      solveList: [] // 解决方案列表
    }
  },
  filters: {
    timeFormat
  },
  computed: {
    showSolve () {
      return this.solveList.length === 0 ? 'false' : 'true'
    }
  },
  mounted () {
    this.getSolveList({ TypeId: this.solveId })
  },
  methods: {
    // 获取解决方案中心
    async getSolveList (data) {
      const res = await getSolveList(data)
      // console.log(res)
      if (res.Msg === '获取成功') {
        this.solveList = res.Data
        this.solveList.forEach(item => {
          item.TitlePic = request.defaults.baseURL + item.TitlePic
          // console.log(item.TitlePic, 'item.TitlePicitem.TitlePicitem.TitlePic')
        })
      }
      // console.log(this.solveList)
    },
    goSolveShow (item) {
      this.$router.push({ path: `/solveShow/${item.ID}` })
      this.$store.commit('getActiveIndex', '/solve')
    }
  }

}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.solveBox{
  width: 1200px*$sun;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .solveItem{
    float: left;
    width: 386px*$sun;
    height: 376px*$sun;
    background: #F8F8F8;
    box-sizing: content-box;
    margin: 0 7px*$sun;
    margin-bottom: 20px*$sun;
    // 动画
    transition: all 0.2s;
    cursor: pointer;
    .solveItemImg{
      width: 386px*$sun;
      height: 240px*$sun;
      margin: 0;
      overflow: hidden;
      .CNewItemImgSelf{
        width: 386px*$sun;
        height: 100%;
        img{
          width: 386px*$sun;
          height: 100%;
        }
      }
    }
    .solveItemTitle{
      font-size: 24px*$sun;
      padding: 20px*$sun;
      padding-bottom: 14px*$sun;
      font-weight: 500;
    }
    .solveItemP{
      padding: 0 20px*$sun;
      font-size: 20px*$sun;
      color: #999999;
      font-weight: 500;
    }
  }
          // 动画
    .solveItem:hover img{
      animation: move .5s linear forwards;
     }
     .solveItem:hover .CNewItemImgSelf{
      animation: move .5s linear forwards;
     }
    @keyframes move {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(1.1);
      }
    }
     .solveItem:hover{
   /* 盒子向上移动 */
    transform: translateY(-2px*$sun);
    /* 背景 */
    box-shadow: 5px*$sun 5px*$sun 5px*$sun rgba(19, 19, 20, 0.15);
    // text-shadow: 5px*$sun 5px*$sun 5px*$sun #7676f3;
 }
}
.noSolveItem{
  width: 1200px*$sun;
  display: flex;
  justify-content: center;
  img{
    width: 300px*$sun;
    height: 300px*$sun;
  }
}
</style>
